/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FinancialPlanUpdateLoanRepaymentRequestDto
 */
export interface FinancialPlanUpdateLoanRepaymentRequestDto {
  /**
   *
   * @type {number}
   * @memberof FinancialPlanUpdateLoanRepaymentRequestDto
   */
  amount: number;
}

export function FinancialPlanUpdateLoanRepaymentRequestDtoFromJSON(
  json: any
): FinancialPlanUpdateLoanRepaymentRequestDto {
  return FinancialPlanUpdateLoanRepaymentRequestDtoFromJSONTyped(json, false);
}

export function FinancialPlanUpdateLoanRepaymentRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FinancialPlanUpdateLoanRepaymentRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    amount: json["amount"],
  };
}

export function FinancialPlanUpdateLoanRepaymentRequestDtoToJSON(
  value?: FinancialPlanUpdateLoanRepaymentRequestDto | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    amount: value.amount,
  };
}
